// extracted by mini-css-extract-plugin
export default {"eachGroup":"EachGroup_eachGroup__lc6o7","eachGroupColor":"EachGroup_eachGroupColor__7b9wb","eachGroupName":"EachGroup_eachGroupName__ZOgFZ"};